<template>
    <div
        class="ProductShipping-messagesSelected"
        :class="CountDownExpired ? 'SlotExpired' : ''"
        v-if="selectedDeliveryDateStart !== ''"
    >
        <!-- Line break for modal -->
        <p v-if="fromModalCalendar">
            <!-- <span class="title">Planifié le</span><br> -->
            <span class="slot">{{ selectedDeliveryDateStart | formatDate }} entre {{ selectedDeliveryHours }} 
                <svg
                    v-if="!CountDownExpired"
                    v-svg
                    symbol="ValideGreen"
                    size="0 0 12 12"
                    role="presentation"
                    class="icon--inline Icon-Valide override-icon"
                ></svg>
            </span>
        </p>
        <!-- One Line for Fp -->
        <p v-else>
            <svg
                v-if="!CountDownExpired"
                v-svg
                symbol="ValideGreen"
                size="0 0 12 12"
                role="presentation"
                class="icon--inline Icon-Valide override-icon"
            ></svg>
            <span>Planifié le {{ selectedDeliveryDateStart | formatDate }} entre {{ selectedDeliveryHours }}</span>
        </p>
            
        <!-- Modify link -->
        <button @click.prevent="emitClickAction" :class="isModifySlotBtnDisabled ? 'disabledBtn' : ''">modifier</button>

        <!-- CountDown Slot validity -->
        <CountDown 
            v-if="!isLead && !isRFIDCard"
            @CountDownExpired="setCountDownExpired"
            @restartCountDown="setCountDownRestarted"
        />
    </div>
</template>

<script>
import CountDown from '@/components/CountDown/CountDown.vue';
import '@/includes/Product/ProductShippingMessages/ProductShippingMessages.scss';
import { mapGetters } from "vuex";

export default{
    name: 'ProductShippingMessage',

    props: {
        selectedDeliveryDateStart: {
            type: Object,
            default: {}
        },
        selectedDeliveryHours: {
            type: String,
            default: ""
        },
        fromModalCalendar: {
            type: Boolean,
            default: false,
        },
        isModifySlotBtnDisabled: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            CountDownExpired: false,
        };
    },

    components: {
        CountDown
    },

    methods: {
        setCountDownExpired() {
            this.CountDownExpired = true;
        },

        setCountDownRestarted() {
            this.CountDownExpired = false;
        },

        onModifyGtmEvent() {
            let customDatasToSave = {
                modified_info: 'calendar',
                page_name: McpGtm?.gtmData?.page_name ?? ''
            };

            if(window.McpGtm) McpGtm.pushCustomDataLayerWithoutModel('click_modify_info', customDatasToSave);
        },

        //Modify slot via btn modify
        emitClickAction() {
            if(!this.isModifySlotBtnDisabled) {
               this.onModifyGtmEvent();
               this.$emit('modifySlot'); 
            } 
        }
    },

     computed: {
        ...mapGetters({ 
            isLead: "isLead",
            isRFIDCard: "getIsRFIDCard"
        }),
    },
}
</script>

<style lang="scss">
    .ProductShipping-messagesSelected {
        p {
            color: #34a853;
        }
        
        .icon--inline.Icon-Valide {
            margin-right: 5px;
        }

        .disabledBtn {
            display: none;
        }
    } 
</style>